export default __webpack_public_path__ + "static/media/work_portfolio_works.66673ab6.jpg";